import type {
  AvailabilityMap,
  AvailabilityStatus,
  WeeklyScheduleToday,
} from '../types';

/**
 * Resolves the effective availability status for a contributor+solution on a given day.
 *
 * Priority order (highest to lowest):
 *   1. weeklyScheduleToday / weekly schedule entry for the day
 *   2. Base availability (qualification level)
 *
 * Used by ContributorWeekView to render per-day status in the week grid.
 */
export function resolveEffectiveStatus(
  contributorId: string,
  solutionId: string,
  weeklyScheduleForDate: WeeklyScheduleToday,
  baseAvailability: AvailabilityMap
): AvailabilityStatus | undefined {
  // 1. Weekly schedule override
  const daySchedule = weeklyScheduleForDate[contributorId];
  if (daySchedule && daySchedule[solutionId] !== undefined) {
    return daySchedule[solutionId];
  }

  // 2. Base availability
  return baseAvailability[contributorId]?.[solutionId];
}
